import { useState, useContext } from "react"
import readAloud from './readAloud'; 
import ReadAloudIcon from '../../images/icons/sound.png';
import ReadAloudIconWhite from '../../images/icons/sound-white.png';
import spinner from '../../images/spinner-ripple.svg'
import { QuestionnaireContext } from '../../StateManagment/Questionnaire';
import Location from '../../hooks/Location';
import { hasReadAloudVoice } from '../../utils/listOfLanguages';

/**
 * @param {object} props
 * @param {string} props.text - De voor te lezen tekst (vraag, optie, rij- of kolomtitel)
 * @param {string} [props.type] - Vraagtype; bepaalt alleen de kleur van het icoon
 */
const ReadAloudButton = ({text, type}) => {
      // Context
      const { settings } = useContext(QuestionnaireContext);
      // Taal uit de vragenlijst-URL, zodat de eigen stem in de juiste taal voorleest.
      const languageCode = Location()[8];
      // Niet elke taal heeft een stem. Zonder deze poort staat er een knop die
      // stil niets doet: de stemdienst geeft 400 en readAloud.js logt dat alleen
      // in de console. Liever geen knop dan een dode knop.
      const canReadAloud = hasReadAloudVoice(languageCode);

    // State
    const [loadingReadingAloud, setLoadingReadingAloud] = useState(false)

    // Handlers
    const onClick = (e) => {
      e.stopPropagation();     // don't toggle the input
      readAloud(e, setLoadingReadingAloud);
    };

    return (
        <>
            {settings.readAloud && canReadAloud && (
                <>
                    {loadingReadingAloud ? (
                        <img 
                        className='read-aloud-icon loading-spin'
                        src={spinner} 
                        alt="Loading" 
                        />
                    ) : ( 
                        <img 
                        src={type === 'paragraph' ? ReadAloudIcon : ReadAloudIconWhite} 
                        alt="Voorlezen"
                        className='read-aloud-icon'
                        data-question={text}
                        data-language={languageCode || 'nl'}
                        onMouseDown={(e) => e.preventDefault()} // avoid focusing/activating the label
                        onClick={onClick}
                        aria-label="Voorlezen"
                        title="Voorlezen"
                        />
                    )}
                </>
            )}
        </>
    );
}

export default ReadAloudButton